module.exports = __webpack_public_path__ + "img/Navigate.a2ee1534.svg";